import React from "react";

/**
 * Organic wave between Stitch sections (home.html path).
 * from/to use brand colour utility classes for fill (e.g. text-spectrum-blue).
 * Height is set in whole CSS px rather than from the viewBox ratio: a fractional
 * box leaves the last device row half-painted, which reads as a hairline seam.
 */
const WaveDivider = ({
  fromClassName = "bg-spectrum-blue",
  waveClassName = "text-surface-white",
  heightClassName = "h-3 sm:h-5 md:h-6 lg:h-9 xl:h-12",
  flip = false,
  className = "",
}) => {
  return (
    <div
      className={`w-full overflow-hidden leading-none ${heightClassName} ${fromClassName} ${className}`.trim()}
      aria-hidden="true"
    >
      <svg
        className={`h-full w-full block ${waveClassName} ${flip ? "rotate-180" : ""}`}
        fill="currentColor"
        preserveAspectRatio="none"
        viewBox="0 0 1440 48"
      >
        <path d="M0,24 C360,48 720,0 1080,32 C1260,48 1380,20 1440,24 L1440,48 L0,48 Z" />
      </svg>
    </div>
  );
};

export default WaveDivider;
